import { render, staticRenderFns } from "./t-about.vue?vue&type=template&id=2323c216&scoped=true&"
import script from "./t-about.vue?vue&type=script&lang=js&"
export * from "./t-about.vue?vue&type=script&lang=js&"
import style0 from "@/css/Main_style.scss?vue&type=style&index=0&id=2323c216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2323c216",
  null
  
)

export default component.exports